/**
 * Public API Client
 *
 * Separate Axios instance for the unauthenticated public-share surface
 * (`/api/v1/public/...`). Unlike {@link apiClient} it:
 * - does NOT inject the `X-Workspace-Id` header (access is token-based),
 * - does NOT run the session-expiry interceptor (a public viewer has no BFF
 *   session, so a 401/403 must NOT trigger the authenticated logout flow),
 * - still sends `withCredentials` so the per-share password cookie
 *   (`share_pwd_<token>`) travels on same-origin subrequests.
 *
 * Errors are still transformed into the shared typed `ApiError` shape so public
 * pages can branch on status (404 not found, 410 revoked, 403 password gate).
 */
import axios from 'axios';
import type { AxiosError } from 'axios';
import { API_CONFIG } from '@/config/api';
import { transformApiError } from './apiErrors';

export const publicApiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

publicApiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => Promise.reject(transformApiError(error))
);

export default publicApiClient;
